"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var Icon_1 = require("office-ui-fabric-react/lib/Icon");
var mobx_react_1 = require("mobx-react");
var Persona_1 = require("office-ui-fabric-react/lib/Persona");
var PersonaControl_1 = require("owa-persona/lib/components/PersonaControl");
var React = require("react");
var styles = require('./FindRecipient.scss');
var classNames = require('classnames/bind').bind(styles);
var FindRecipient = /** @class */ (function (_super) {
    tslib_1.__extends(FindRecipient, _super);
    function FindRecipient() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.addSelectedRecipient = function (evt) {
            evt.preventDefault();
            _this.props.addRecipientAction(_this.props.findRecipient);
        };
        _this.maskRecipient = function (evt) {
            evt.preventDefault();
            evt.stopPropagation();
            if (_this.props.maskRecipientAction) {
                _this.props.maskRecipientAction(_this.props.findRecipient);
            }
        };
        return _this;
    }
    FindRecipient.prototype.render = function () {
        var containerClassName = classNames(styles.container, {
            isHighlighted: this.props.isHighlighted,
        });
        var _a = this.props, findRecipient = _a.findRecipient, maskRecipientAction = _a.maskRecipientAction;
        var recipientName = findRecipient.EmailAddress.Name;
        var recipientEmail = findRecipient.EmailAddress.EmailAddress;
        return (React.createElement("div", { className: containerClassName, onClick: this.addSelectedRecipient },
            React.createElement("div", { className: styles.personaContainer },
                React.createElement("div", { className: styles.personaImage },
                    React.createElement(PersonaControl_1.default, { name: recipientName, emailAddress: recipientEmail, size: Persona_1.PersonaSize.size32, showPersonaDetails: false })),
                React.createElement("div", { className: styles.personaText },
                    React.createElement("span", { className: classNames(styles.personaLineOne, styles.personaTextLine) }, recipientName),
                    React.createElement("span", { className: classNames(styles.personaLineTwo, styles.personaTextLine) }, recipientEmail))),
            maskRecipientAction && (React.createElement("div", { className: styles.maskRecipientButton, onClick: this.maskRecipient },
                React.createElement(Icon_1.Icon, { className: styles.cancelIcon, iconName: "Cancel" /* Cancel */ })))));
    };
    FindRecipient = tslib_1.__decorate([
        mobx_react_1.observer
    ], FindRecipient);
    return FindRecipient;
}(React.Component));
exports.default = FindRecipient;
//# sourceMappingURL=FindRecipient.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-recipient-common/lib/components/FindRecipient.js
// module id = 2921
// module chunks = 2 3 63